import {GET_LEADER_REQUESTS} from "../../../enums/Request/request.types";
export const getLeaderRequestsAction = (data)=> {
    return {
        type:GET_LEADER_REQUESTS,
        payload:data,
    };
};
